






























































import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo() {
    return {
      title: `${this.$t('meta.cguTitle')}`,
      htmlAttrs: {
        lang: this.$root.$i18n.locale
      },
      meta: [
        {
          name: 'description',
          content: `${this.$t('meta.cguDescription')}`
        },
        {
          name: 'og:title',
          content: `${this.$t('meta.cguTitle')}`
        },
        {
          name: 'og:description',
          content: `${this.$t('meta.cguDescription')}`
        },
        {
          name: 'twitter:title',
          content: `${this.$t('meta.cguTitle')}`
        },
        {
          name: 'twitter:description',
          content: `${this.$t('meta.cguDescription')}`
        }
      ]
    }
  }
})
export default class CGU extends Vue {

}
